import classes from '@/components/Shares/Button.module.css';
import { Icons } from '@/components/Shares/Icons';
import { useModalAction } from '@/providers/ModalActionProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Button, Flex, Group, Image, NumberFormatter, Paper, SimpleGrid, Stack, Text, rem } from '@mantine/core';
import { KycCongratsMobile } from './KycCongratsMobile';
export const KycCongratsInfo: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    setOpenModal
  } = useModalAction();
  return <Flex direction="column" h="100%" align="center" justify={{
    base: 'center',
    lg: 'start'
  }} p={{
    base: 20,
    lg: 10
  }}>
      <KycCongratsMobile />

      <Stack gap={0} w={{
      base: '100%',
      sm: 369,
      lg: '100%'
    }}>
        <Group justify="space-between" w={{
        base: '97%',
        sm: '100%'
      }} wrap="nowrap">
          <Stack gap={0}>
            <Text fz="xs" fw={700} tt="uppercase" c="var(--text-prime)">
              {i18n._('PRIMEORB')}
            </Text>
            <Text fz={{
            base: rem(21),
            sm: rem(24),
            lg: rem(32)
          }} className={gunterzBold.className} c="var(--text-white)" lh={rem(32)}>
              {i18n._('#1477')}
            </Text>
          </Stack>

          <Stack gap={0}>
            <Text fz="xs" fw={700} tt="uppercase" c="var(--text-prime)" ta="center">
              {i18n._('Level')}
            </Text>
            <Text fz={{
            base: rem(21),
            sm: rem(24),
            lg: rem(32)
          }} className={gunterzBold.className} c="var(--text-white)" lh={rem(32)} ta="center">
              {i18n._('2')}
            </Text>
          </Stack>

          <Stack gap={0}>
            <Text fz="xs" fw={700} tt="uppercase" c="var(--text-prime)" ta="right" style={{
            textWrap: 'nowrap'
          }}>
              {i18n._('RARITY INDEX')}
            </Text>
            <Text fz={{
            base: rem(21),
            sm: rem(24),
            lg: rem(32)
          }} className={gunterzBold.className} c="var(--text-white)" lh={rem(32)} ta="right">
              {i18n._('711')}
            </Text>
          </Stack>
        </Group>

        <Stack gap={10} w={{
        base: '97%',
        sm: '100%'
      }}>
          <Paper radius={5} p={10} bd="1px solid var(--icon-primary)" bg="transparent">
            <Group justify="space-between">
              <Text fz="xs" fw={700} tt="uppercase" c="var(--text-prime)">
                {i18n._('FUR')}
              </Text>
              <Text fz="xs" fw={700} tt="uppercase" c="var(--text-purple)">
                {i18n._('COMMON')}
              </Text>
            </Group>
            <Text fz={{
            base: 14,
            sm: 18,
            lg: 20
          }} className={gunterzBold.className} c="var(--text-white)" style={{
            textWrap: 'nowrap'
          }}>
              {i18n._('COLDFRONT BASIC')}
            </Text>
          </Paper>

          <Paper radius={5} p={10} bd="1px solid var(--icon-primary)" bg="transparent">
            <Group justify="space-between">
              <Text fz="xs" fw={700} tt="uppercase" c="var(--text-prime)">
                {i18n._('EYES')}
              </Text>
              <Text fz="xs" fw={700} tt="uppercase" c="var(--text-purple)">
                {i18n._('COMMON')}
              </Text>
            </Group>
            <Text fz={{
            base: 14,
            sm: 18,
            lg: 20
          }} className={gunterzBold.className} c="var(--text-white)">
              {i18n._('MAD BLUE')}
            </Text>
          </Paper>

          <Paper radius={5} p={10} bd="1px solid var(--icon-primary)" bg="transparent">
            <Group justify="space-between">
              <Text fz="xs" fw={700} tt="uppercase" c="var(--text-prime)">
                {i18n._('MOUTH')}
              </Text>
              <Text fz="xs" fw={700} tt="uppercase" c="var(--text-purple)">
                {i18n._('COMMON')}
              </Text>
            </Group>
            <Text fz={{
            base: 14,
            sm: 18,
            lg: 20
          }} className={gunterzBold.className} c="var(--text-white)">
              {i18n._('ARGH')}
            </Text>
          </Paper>

          <Paper radius={5} p={10} bd="1px solid var(--text-pink)" bg="transparent" pos="relative">
            <Image src="/assets/kyc/congratulation.svg" alt="decoration" w={{
            base: 94,
            sm: 164,
            lg: 234
          }} h={{
            base: 75,
            sm: 144,
            lg: 234
          }} pos="absolute" right={{
            base: '-4rem',
            sm: '-7rem',
            lg: '-11rem'
          }} bottom={{
            base: '-1rem',
            sm: '-4rem',
            lg: '-6rem'
          }} />
            <Group justify="space-between">
              <Text fz="xs" fw={700} tt="uppercase" c="var(--text-pink)">
                {i18n._('ARMOR')}
              </Text>
              <Text fz="xs" fw={700} tt="uppercase" c="var(--text-purple)">
                {i18n._('LEGENDARY')}
              </Text>
            </Group>
            <Text fz={{
            base: 14,
            sm: 18,
            lg: 20
          }} className={gunterzBold.className} c="var(--text-pink)">
              {i18n._('GALAXY SILVER')}
            </Text>
          </Paper>

          <Stack gap={10} mt={30}>
            <Text fz="xs" fw={700} tt="uppercase" c="var(--text-prime)">
              {i18n._('REWARDS')}
            </Text>
            <SimpleGrid cols={2} spacing={10}>
              <Paper radius={5} p={10} bd="1px solid var(--icon-primary)" bg="transparent">
                <Text fz="xs" fw={700} tt="uppercase" c="var(--text-prime)">
                  {i18n._('MULTIPLIER')}
                </Text>
                <Text fz={{
                base: 14,
                sm: 18,
                lg: 20
              }} className={gunterzBold.className} c="var(--text-white)">
                  <NumberFormatter value={1.3} decimalSeparator="." suffix="X" />
                </Text>
              </Paper>

              <Paper radius={5} p={10} bd="1px solid var(--icon-primary)" bg="transparent">
                <Text fz="xs" fw={700} tt="uppercase" c="var(--text-prime)">
                  {i18n._('RAKEBACK')}
                </Text>
                <Text fz={{
                base: 14,
                sm: 18,
                lg: 20
              }} className={gunterzBold.className} c="var(--text-white)">
                  <NumberFormatter value={5} decimalSeparator="." suffix="%" />
                </Text>
              </Paper>
            </SimpleGrid>
          </Stack>
        </Stack>

        <Button h={46} mt={20} classNames={{
        root: classes.root
      }} fz={rem(13)} onClick={() => setOpenModal(null)} leftSection={<Icons className="icon-pr-line-log-in" fontSize={25} />}>
          {i18n._('Start Playing')}
        </Button>
      </Stack>
    </Flex>;
};